import "./portfolio.css";

import IMG1 from "../../assets/cinevibes.png";
import IMG2 from "../../assets/visual.png";
import IMG3 from "../../assets/chatskoot.png";
import IMG4 from "../../assets/notes.png";
import IMG5 from "../../assets/snake.png";
import IMG6 from "../../assets/weather.png";
import React from "react";

//Portfolio function
const Portfolio = () => {
  const soloProjects = [
    {
      id: 1,
      title: "CineVibes",
      img: IMG1,
      description:
        "An Movie website which hosts information related to movies, television shows, OTT content.",
      technologies: "Html | SCSS | Javascript | React Js",
      link: "https://cinevibes.vercel.app/",
      github: "https://github.com/YUVRAJSHARMA24/CineVibes/tree/main",
    },
    {
      id: 2,
      title: "Sorting Visualizer",
      img: IMG2,
      description: "The Shortest Path Finding App between two points",
      technologies: "React | Tailwind",
      link: "https://shortestpathfinding.vercel.app/",
      github: "https://github.com/YUVRAJSHARMA24/Track-Detector",
    },
    {
      id: 3,
      title: "ChatSkoot",
      img: IMG3,
      description:
        "A Realtime Private Chat Application using react.js and firebase",
      technologies: "React | Firebase | Git",
      link: "https://chatsapp-alpha.vercel.app/login/",
      github: "https://github.com/YUVRAJSHARMA24/Chat-Application",
    },
    {
      id: 4,
      title: "Notes App",
      img: IMG4,
      description:
        "Notes is a good helper to manage your schedules, notes & easier than any other memo apps.",
      technologies: "React",
      link: "https://todo-51n6anxze-yuvrajsharma24.vercel.app/",
      github: "https://github.com/YUVRAJSHARMA24/TO-DO-LIST",
    },
    {
      id: 5,
      title: "Snake Game",
      img: IMG5,
      description:
        "The main objective of the player is to catch the maximum number of Food without hitting the wall or itself",
      technologies: "Html | CSS | Javascript",
      link: "https://snake-game-kohl-delta.vercel.app/",
      github: "https://github.com/YUVRAJSHARMA24/Snake-Game",
    },
    {
      id: 6,
      title: "Weather App",
      img: IMG6,
      description:
        "Get the weather forecast in a beautiful and powerful app. See current and forecasted weather with a smart layout",
      technologies: "Html | Scss | Javascript",
      link: "https://weather-umber-xi.vercel.app/",
      github: "https://github.com/YUVRAJSHARMA24/Weather-App",
    },
  ];

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Projects</h2>

      <div className="container portfolio__container">
        {soloProjects.map((pro) => (
          <article className="portfolio__item" key={pro.id}>
            <div className="portfolio__item-image">
              <img src={pro.img} alt={pro.title} />
            </div>
            <div className="portfolio__item-content">
              <h3>{pro.title}</h3>
              <p>{pro.description}</p>
              <p>{pro.technologies}</p>
            </div>
            <div className="portfolio__item-cta">
              <a
                href={pro.github}
                target="_blank"
                className="btn"
                rel="noreferrer"
              >
                GitHub
              </a>
              <a
                href={pro.link}
                target="_blank"
                className="btn btn-primary"
                rel="noreferrer"
              >
                Live Demo
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
